( function( $ ) {
  $( '.__blob_image' ).on( 'click', function() {
    if( ! $( this ).hasClass( '__active' ) ) {
      $( '.__blob_image' ).removeClass( '__active' );
      $( this ).addClass( '__active' );

      var blob_index = $( this ).data( 'blob' );

      $( '.__blob_content' ).removeClass( '__active' );
      $( '[data-content="' + blob_index + '"]' ).addClass( '__active' );

      if( $( window ).width() <= 622 ) {
        $( 'html, body' ).animate( {
          scrollTop: $( '.__blob_contents' ).offset().top - 80
        }, 1000 );
      }
    }
  } );
} ) ( jQuery );